import React from 'react';
import { Image } from '@fluentui/react-components';

import { useAccreditedBadgeStyles } from './AccreditedBadge.style';

interface AccreditedBadgeProps {
  src: string
  alt: string
  children?: React.ReactNode
}

const AccreditedBadge: React.FC<AccreditedBadgeProps> = (props) => {
  const { src, alt, children } = props;
  const styles = useAccreditedBadgeStyles();
  const renderedLabel = children && (
    <div className={styles.accreditedImgLabel}>{children}</div>
  );

  return (
    <div className={styles.accreditedImgWrapper}>
      <Image className={styles.accreditedImg} shape="rounded" src={src} alt={alt} />

      {renderedLabel}
    </div>
  );
};

export default AccreditedBadge;
